import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const BeeperCodeModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 28.8em;

	@media screen and (max-width: ${theme.point820}) {
		width: 100%;
		margin-top: 2.5em;
	}

	@media screen and (max-width: ${theme.point720}) {
		width: 100%;
	}
`
BeeperCodeModalWrapper.displayName = 'ModalBeeperCodeModalWrapper'

export const InputBeeperCodeWrap = styled.div`
	position: relative;
	font-size: 1rem;
	width: 100%;
	min-width: auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border: 2px solid ${colorTheme.input.field};
	border-radius: 0.55em;
	margin-bottom: .38em;

	input {
		height: 3.4em;
		padding: 0 1.09em;
		background-color: ${colorTheme.input.background};
		width: 100%;
		font-family: ${theme.fontRobotoMedium};
		border: none;
		color: ${colorTheme.input.field};
		font-size: 1.38em;
		line-height: normal;

		&:focus {
			box-shadow: 0 .25em 0.69em rgba(0, 0, 0, 0.22);
		}

		&::placeholder {
			color: ${colorTheme.input.focus.text};
			font-style: normal;
			font-weight: 700;
			line-height: normal;
			text-align: left;
		}
	}

	img {
		font-size: 1em;
		position: absolute;
		right: 2.3em;
		top: calc(50% - 0.7em);
		cursor: pointer;
		width: 2.31em;
		height: 1.44em;
	}

	&.active {
		border: 2px solid ${colorTheme.input.focus.border};
	}

	&.error {
		border: 2px solid ${colorTheme.input.error.border};
	}

	@media screen and (max-width: ${theme.point820}) {
		input {
			font-size: 1.57rem;
			width: 100%;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		input {
			font-size: 1.38em;
		}
	}
`

InputBeeperCodeWrap.displayName = 'InputBeeperCodeWrap'

export const BeeperCodeButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;

	@media screen and (max-width: ${theme.point820}) {
		display: grid;
		gap: 1.25em;
		grid-template-columns: repeat(2, 1fr);
	}
`
BeeperCodeButtonsWrapper.displayName = 'BeeperCodeButtonsWrapper'

export const  ErrorTextWrapper = styled.div`
	min-height: 1.5em;
`
export const ErrorText = styled.div`
	font-family: ${theme.fontRobotoMedium};
	font-weight: 500;
	font-size: 1.25em;
	line-height: 1.15em;
	text-align: center;
	color: ${colorTheme.input.error.text};
	margin-bottom: .63em;

	@media screen and (max-width: ${theme.point820}) {
		margin-bottom: 1.88em;
	}
`
ErrorText.displayName = 'ErrorText'
